import { ChevronLeft } from 'lucide-react';
import { Checkbox } from '@/components/ui/checkbox';
import { AritoIcon } from '@/components/custom/erp';

interface SidebarProps {
  showSidebar: boolean;
  toggleSidebar: () => void;
}

export const Sidebar = ({ showSidebar, toggleSidebar }: SidebarProps) => {
  if (!showSidebar) return null;

  return (
    <div className='w-64 overflow-y-auto border-r border-gray-200 bg-white'>
      <div className='p-4'>
        <div className='mb-4 flex flex-row items-center gap-x-2'>
          <AritoIcon icon={538} />
          <h2 className='text-lg font-medium'>Phân nhóm</h2>
        </div>

        <div className='space-y-4'>
          {/* Base level items */}
          <div className='flex items-center'>
            <Checkbox
              id='filter-not-grouped'
              onCheckedChange={() => {}}
              className='h-4 w-4 rounded border-gray-300 text-blue-600'
            />
            <label htmlFor='filter-not-grouped' className='ml-2 text-sm text-gray-700'>
              Chưa phân nhóm
            </label>
          </div>

          {/* Group 12312 with nested item */}
          <div>
            <div className='flex items-center'>
              <Checkbox
                id='filter-12312'
                onCheckedChange={() => {}}
                className='h-4 w-4 rounded border-gray-300 text-blue-600'
              />
              <label htmlFor='filter-12312' className='ml-2 text-sm text-gray-700'>
                12312
              </label>
            </div>
            {/* Nested item for 12312 */}
            <div className='ml-6 mt-2 flex items-center'>
              <Checkbox
                id='filter-3123-1'
                onCheckedChange={() => {}}
                className='h-4 w-4 rounded border-gray-300 text-blue-600'
              />
              <label htmlFor='filter-3123-1' className='ml-2 text-sm text-gray-700'>
                3123
              </label>
            </div>
          </div>

          {/* Group Nhóm khách hàng 1 with nested item */}
          <div>
            <div className='flex items-center'>
              <Checkbox
                id='filter-customer-group-1'
                onCheckedChange={() => {}}
                className='h-4 w-4 rounded border-gray-300 text-blue-600'
              />
              <label htmlFor='filter-customer-group-1' className='ml-2 text-sm text-gray-700'>
                Nhóm khách hàng 1
              </label>
            </div>
            {/* Nested item for Nhóm khách hàng 1 */}
            <div className='ml-6 mt-2 flex items-center'>
              <Checkbox
                id='filter-3123-2'
                onCheckedChange={() => {}}
                className='h-4 w-4 rounded border-gray-300 text-blue-600'
              />
              <label htmlFor='filter-3123-2' className='ml-2 text-sm text-gray-700'>
                3123
              </label>
            </div>
          </div>
        </div>
      </div>
      <div className={`absolute left-64 top-24 z-10 -translate-x-1/2 transform`}>
        <button
          onClick={toggleSidebar}
          className='flex h-6 w-6 items-center justify-center rounded-full border border-gray-300 bg-gray-200 shadow-sm hover:bg-gray-100'
        >
          <ChevronLeft className='h-4 w-4' />
        </button>
      </div>
    </div>
  );
};
